export default "__VITE_ASSET__0plJ6arA__"